import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    deleteMidSession: [],
    loading: false,
    error: null,
}

const deleteMidSessionSlice = createSlice({
    name: "deleteMidSession",
    initialState,
    reducers: {
        fetchdeleteMidSessionSuccess: (state, action) => {
            state.loading = false,
            state.deleteMidSession= action.payload;
        },
        fetchdeleteMidSessionFailure: (state, action) => {
            state.loading = false,
                state.error = action.payload;
        },
    },
})

export const {
    fetchdeleteMidSessionSuccess,
    fetchdeleteMidSessionFailure,
} = deleteMidSessionSlice.actions;

export default deleteMidSessionSlice.reducer;